<template>
  <div id="slideshow">
    <img
      v-for="(image, index) of images" :key="index"
      class="image"
      :class="{ fadein: imageIndex === index, fadeout: imageIndex !== index }"
      :src="image"
      @touchstart="onTouchstart" @touchmove="onTouchmove" @touchend="onTouchend"/>
    <div id="slideshow-bottom">
      <div class="season-text">Spring to Summer</div>
      <div class="selector-container" v-for="(_, idx) of images" :key="idx" @click="showWork(idx)">
        <div class="selector" :class="{ selected: idx === imageIndex }"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  beforeMount() {
    this.importAll(require.context("@/assets/image/slideshow", true, /\.(png|jpg)$/));
  },
  data: () => ({
    images: [],
    imageIndex: 0,
    isDragging: false,
    touchStartPosition: null,
    touchEndPosition: null,
  }),
  methods: {
    importAll(images) {
      for (const image of images.keys()) {
        this.images.push(images(image));
      }
    },
    showWork(idx) {
      this.imageIndex = idx;
    },
    onTouchstart(e) {
      this.isDragging = true;
      this.touchStartPosition = this.touchEndPosition = { x: e.touches[0].pageX, y: e.touches[0].pageY };
    },
    onTouchmove(e) {
      if (!this.isDragging) { return; }
      this.touchEndPosition = { x: e.touches[0].pageX, y: e.touches[0].pageY };
    },
    onTouchend() {
      if (Math.abs(this.touchStartPosition.y - this.touchEndPosition.y) > 50) {
        this.isDragging = false;
        return;
      } else if (this.touchStartPosition.x < this.touchEndPosition.x) {
        if (this.imageIndex >= 1) { this.showWork(this.imageIndex - 1); }
      } else if ( this.touchStartPosition.x > this.touchEndPosition.x ) {
        if (this.imageIndex < (this.images.length - 1)) { this.showWork(this.imageIndex + 1); }
      }
      this.isDragging = false;
    }
  }
};
</script>

<style lang="scss" scoped>
$animation-time: 1s;

#slideshow {
  position: relative;
  display: flex;
  justify-content: center;
  margin: 87px auto 0 auto;
  height: 394px;
}

@media (max-width: $mobile-vw - 1px) {
  #slideshow {
    max-width: 331px;
  }
}

.image {
  position: absolute;
  object-fit: contain;
  z-index: 1;
  width: 100%;
  height: 100%;
  object-position: 50% 16%;
}

#slideshow-bottom {
  z-index: 2;
  display: flex;
  position: absolute;
  align-items: center;
  line-height: 1.0;
  left: 28px;
  bottom: -27px;
  .selector-container {
    cursor: pointer;
    height: 5px;
    width: 5px;
    padding: 6px;
  }
  .selector {
    height: 3px;
    width: 3px;
    border-radius: 50%;
    background-color: #d2d2d2;
    &.selected {
      background-color: #000000;
    }
  }
  .season-text {
    font-size: 10px;
    margin-left: 5px;
    line-height: 2em;
  }
}

@media (min-width: $mobile-vw) {
  #slideshow {
    margin: 82px 210px 100px 202px;
    width: 767px;
    height: 665px;
  }

  .image {
    width: 100%;
    height: 100%;
    object-position: 20% 90%;
  }

  #slideshow-bottom {
    left: 56px;
    bottom: -42px;
    .selector-container {
      height: 5px;
      width: 5px;
      padding: 10px;
      margin-right: 1px;
    }
    .selector {
      height: 5px;
      width: 5px;
    }
    .season-text {
      font-size: 13px;
      letter-spacing: 0.06em;
      margin: 0 10px 3px 10px;
      line-height: 1.2;
    }
  }
}

.fadeout {
  z-index: 1;
  opacity: 0;
  transition: opacity $animation-time ease-in;
}
.fadein {
  z-index: 2;
  opacity: 1;
  transition: opacity $animation-time ease-in;
}
</style>